import app from 'flarum/forum/app';
import Stream from 'flarum/common/utils/Stream';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';

export default class ChangeEmailModal extends Modal {

  oninit(vnode) {
    super.oninit(vnode);
    this.password = Stream('');
    this.passwordConfirmation = Stream('');
    this.currentPassword = Stream('');
  }

  className() {
    return 'ChangePasswordModal Modal--small';
  }

  title() {
    return app.translator.trans('core.forum.change_password.title');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form Form--centered">
          <div className="Form-group">
            <div className="Form-group">
              <input
                type="password"
                name="currentPassword"
                className="FormControl"
                placeholder={app.translator.trans('lltq-reset-password.forum.password_modal.current_password_placeholder')}
                bidi={this.currentPassword}
                disabled={this.submitLoading}
              />
              <input
                type="password"
                name="newPassword"
                className="FormControl"
                placeholder={app.translator.trans('lltq-reset-password.forum.password_modal.new_password_placeholder')}
                bidi={this.password}
                disabled={this.submitLoading}
              />
            </div>
            <div className="Form-group">
              <input
                type="password"
                name="newPasswordConfirmation"
                className="FormControl"
                placeholder={app.translator.trans('lltq-reset-password.forum.modals.confirm_password_placeholder')}
                bidi={this.passwordConfirmation}
                disabled={this.submitLoading}
              />
            </div>
          </div>
          <div className="Form-group">
            {Button.component(
              {
                className: 'Button Button--primary Button--block',
                type: 'submit',
                loading: this.submitLoading,
              },
              app.translator.trans('lltq-reset-password.forum.modals.submit_button')
            )}
          </div>
        </div>
      </div>
    );
  }

  getAttributes = () => {
    return {
      password: this.password(),
      password_confirmation: this.passwordConfirmation()
    };
  }

  onsubmit(e) {
    e.preventDefault();

    if (this.password() !== this.passwordConfirmation()) {
      error = { alert : { content: app.translator.trans('lltq-reset-password.forum.password_modal.do_not_match_message') } };
      super.onerror(error);
      return;
    }

    this.submitLoading = true;

    app.session.user
      .save(
        this.getAttributes(), { 
          method: "post",
          url: '/api/edit-user',
          meta: { password: this.currentPassword() },
          errorHandler: this.onerror.bind(this)
      })
      .then((request) => {
        this.submitLoading = false;
        this.hide();
      })
      .catch(() => {})
      .then(this.loaded.bind(this));
  }

  onerror(error) {
    if (error.status === 401) {
      error.alert.content = app.translator.trans('core.forum.change_email.incorrect_password_message');
    }

    if (error.response?.errors && error.response?.errors[0]?.code == 'access_forbidden') {
      error.alert.content = app.translator.trans('lltq-reset-password.forum.modals.forbidden_message');
    }

    this.submitLoading = false;
    
    super.onerror(error);
  }
}
